import React from 'react';
import { motion } from 'framer-motion';
export function Urgency() {
  return <section className="w-full bg-[#FDF8F4]/80 py-16 md:py-24" data-id="element-167">
      <motion.div className="max-w-3xl mx-auto px-6" initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-168">
        <div className="font-inter text-lg text-charcoal/90 leading-relaxed space-y-6" data-id="element-169">
          <p data-id="element-170">
            Este precio de <span className="font-bold text-sage" data-id="element-171">$7.18</span> es
            una introducción limitada al mercado. No hay fecha exacta de cuándo
            sube, pero cuando suba, sube. Las personas que lo compraron ayer
            pagaron lo mismo que tú puedes pagar hoy. Las que esperen una semana
            podrían pagar el doble.
          </p>

          <p className="font-semibold text-xl text-charcoal" data-id="element-172">
            Más importante que el precio: cada día que pasa sin una herramienta
            es otro día perdido a la ansiedad. Otro cumpleaños a medias. Otra
            reunión monitoreando tu propio corazón. Otro domingo con esa nube
            encima.
          </p>

          <p className="text-center text-2xl font-lora font-bold text-sage" data-id="element-173">
            El costo real de no actuar no se mide en dólares.
          </p>
        </div>
      </motion.div>
    </section>;
}